<script>
	const year = () => {
		var d = new Date();
		var y = d.getFullYear();
		return y;
  }
  const scrollToTop = () => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
</script>

<main>
  <div class="main-container">
		<section class="section">
			<h1>
			Hi, I'm William.
			</h1>
			<p>
			London based web developer. 
			</p>
			<p>
			Find me on <a rel="noopener" target="_blank" href="https://codepen.io/WilliamKnipe">Codepen</a>, <a rel="noopener" target="_blank" href="https://www.linkedin.com/in/william-knipe-46273241/">LinkedIn</a>, <a rel="noopener" target="_blank" href="https://github.com/WilliamKnipe/">Github</a>, and contact me via <a href="mailto:william@googlemail.com">email</a>.
			</p>
		</section>
		<section class="section">
			<div class="title-container">
				<h2 class="thick-underline">About</h2>
			</div>
			<p>JAMstack, React, Svelte, GraphQL, Go.</p>
			<p>Ambition to build performant and sharp looking projects and to adopt a springer spaniel named Bruce.</p>
		</section>
		<section class="section">
			<div class="title-container">
			<h2>Work</h2>
			</div>
			<div class="card">
			<h3><strong>Full Stack Engineer</strong><span class="date">2019 - {year()}</span></h3>
			<p><strong>Trinny London:</strong> Cosmetics E-commerce based in London.</p>
			<p><strong>Technologies:</strong> React, TypeScript, Node.js, GraphQL, Go, Docker</p>
			</div>
			<div class="card">
			<h3><strong>Junior Developer</strong><span class="date">2018 - 2019</span></h3>
			<p><strong>SoundinTheory:</strong> Exeter based web dev agency.</p>
			<p><strong>Technologies:</strong> HTML, CSS, JavaScript, SVG, PHP.</p>
			<p></p>
			</div>
		</section>
		<section class="section">
			<div class="card">
			<div class="title-container">
				<h2>Dark Mode</h2>
			</div>
			<p>
				What kind of a sick person builds a website without a dark mode? Well, sorry.            
			</p>
			</div>
    </section>
  </div>
    <div class="footer">
      <section class="footer-container">
          <div class="svgContainer">    
              <svg class="coffee-stamp" width="200" height="200" xmlns="http://www.w3.org/2000/svg">
                  <path id="MyPath" fill="none"
                  d="
                      M 50, 100
                      a 50,50 0 1,1 100,0
                      a 50,50 0 1,1 -100,0
                  "
                  />
                  <text font-weight="400" fill="white" textLength="304">
                      <textPath href="#MyPath" textLength="304">
                      London Coffee * is Expensive *
                      </textPath>
                  </text>
              </svg>
          </div>
          <div class="section footer-section">
              <p>Hope you are having a lovely day.</p>
          </div>
          <div class="section button-container footer-section">
              <button class="back-to-top" on:click={scrollToTop}>Back to Top</button>
          </div>
      </section>
    </div>
</main>

<style>
main {
  display: block;
  position: relative;
  border-top: 26px var(--dark-grey) solid;
}
.main-container, .footer-container {
  left: 0;
  right: 0;
  margin: auto;
  max-width: 1200px;
  position: relative;
}
h1, h2 {
  font-weight: 800;
  margin-top: 0px;
}
h1{
  font-size: var(--large-font-size);
  color: var(--darkest-grey);
}
h2{
  font-size: var(--medium-font-size);
  color: var(--darkest-grey);
  position: relative;
}
h2::after {
  content: '';
  left: 0px;
  position: absolute;
  display: block;
  width: 100%;
  background-color: var(--primary-colour);
  bottom: -4px;
  height: 6px;
}
h3 {
  font-weight: 400;
  color: var(--darkest-grey);
  font-size: var(--default-font-size);
}
h3 strong {
  padding: 4px;
  margin-right: 8px;
  background-color: var(--primary-colour);
  color:var(--darkest-grey);
}
.date{
  color: var(--light-grey);
}
.section{
  padding: 0px 16px;
  position: relative;
  display: block;
  margin-top: 32px;
}
p {
  margin-top: 0px;
}
p a{
  text-decoration: none;
  position: relative;
  color: var(--dark-grey);
}
p a::after{
  content: '';
  display: block;
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 3px;
  transition: all 0.3s var(--standard-cubic-bezier);
  background-color: var(--primary-colour);
  z-index: -1;
}
p a:hover::after{
  height: 100%;
}
.title-container{
  display: flex;
}
.card{
  position: relative;
  display: block; 
  margin-bottom: 48px;
}
@media only screen and (min-width: 600px) {
  p a::after{
    height: 18%;
  }
  .card{
    margin-bottom: 60px;
  }
}
.footer-section{
    margin-top: 0px;
}
.button-container{
    text-align: right;
}
.svgContainer{
    height: 0px;
    padding-bottom: 200px;
}
.coffee-stamp{
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 2;
    transition: all 0.6s var(--standard-cubic-bezier);
}
.coffee-stamp:hover{
    transform: rotate(-30deg);
}
.footer{
    background: var(--darkest-grey);
    color: var(--standard-white);
    overflow: hidden;
    position: relative;
}
.back-to-top{
    padding: 8px 16px;
    font-size: var(--default-font-size);
    margin: 16px 0px;
    border: 3px solid var(--standard-white);
    background-color: transparent;
    color: var(--standard-white);
    position: relative;
    transition: all 0.6s var(--standard-cubic-bezier);
}
.back-to-top:hover{
    cursor: pointer;
}
@media only screen and (min-width: 600px) {
    .coffee-stamp{
        top: 0px;
    }
}
</style>